export enum DefaultDateFormats {
  calendarDay = 'D',
  dayName = 'ddd',
  fullDate = 'YYYY-MM-DD',
  pageDetails = 'MMMM D, YYYY',
  pageEditor = 'MMM D, YYYY',
  lastSyncDate = 'DD/MM/YYYY HH:mm',
}



// WEBPACK FOOTER //
// ./src/constants/dateFormats.ts